import { WeatherStationNearestModel } from '../models/weather-station-nearest';

export class WeatherStationNearestAdapter {
  static fromApi(response: any): WeatherStationNearestModel {
    const data = response.data || response;

    return {
      id: data.id,
      code: data.code,
      displayLocation: data.displayLocation,
    };
  }
}
